module.exports = __webpack_public_path__ + "static/media/dist.d14e9c01.png";